var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isHide)?_c('div',{staticClass:"m-alert",class:[
    _vm.type && 'm-alert-' + _vm.type
  ]},[(_vm.message)?_c('p',{staticClass:"m-alert-message"},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.description)?_c('p',{staticClass:"m-alert-description"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_vm._v(" "),(_vm.closable)?_c('span',{staticClass:"m-alert-close-btn",on:{"click":_vm.close}}):_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ae7a272","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/m/alert/alert.vue
// module id = SK87
// module chunks = 90